import { render, staticRenderFns } from "./upsell.vue?vue&type=template&id=f907a02a&scoped=true&"
import script from "./upsell.vue?vue&type=script&lang=js&"
export * from "./upsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907a02a",
  null
  
)

export default component.exports